// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CmLTu .lHsM7{align-items:center;background-color:var(--anchore-color-gray-50);display:flex;font-size:1.1rem;font-weight:700;gap:.5rem;padding:.75rem 1rem}.CmLTu .lHsM7>i.icon{font-size:1.25rem;margin:0}.CmLTu .sO8si{flex:1 1 auto}.CmLTu .HjMoB{display:flex;flex-shrink:0;gap:.25rem;margin-left:2rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CmLTu`,
	"heading": `lHsM7`,
	"title": `sO8si`,
	"extra": `HjMoB`
};
module.exports = ___CSS_LOADER_EXPORT___;
